export default __webpack_public_path__ + "static/media/med.c7a313b1.png";